import * as _ from 'lodash';
import GenerateRequest from './resources';
import { checkLicenseExpiry } from './ResourceValidations';

const req = GenerateRequest();

export default {
  async getOne(params) {
    try {
      await checkLicenseExpiry();
      return (await req.get('location/getOne', { params })).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async allLocationForUser(params, largeDataSet = false) {
    try {
      await checkLicenseExpiry();
      let locData = {};
      if (largeDataSet) {
        locData = await req.post('location/getAllLocationsForUser', params);
      } else {
        locData = await req.get('location/getLocationsForUser', { params });
      }
      return locData.data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async forProject(params) {
    try {
      await checkLicenseExpiry();
      params = { limit: -1, ...params };
      return (await req.get('location', { params })).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async update(location, isProjectAdmin) {
    try {
      await checkLicenseExpiry();
      const locationUpdte = await req.post('location/edit', { form_data: location, isProjectAdmin });
      return locationUpdte.data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async importLocation(params) {
    try {
      await checkLicenseExpiry();
      return (await req.post('location/importCompanyLocationToProjectLocation', params)).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async deleteLocation(params) {
    try {
      await checkLicenseExpiry();
      return (await req.post('location/removeProjectLocation', params)).data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async removeLocations(params) {
    try {
      await checkLicenseExpiry();
      const deletedLoc = await req.post('location/removeLocations', params);
      return deletedLoc;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async getChildNodes(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.get('location/getNodes', { params });
      return data;
    } catch (e) {
      console.log('Error', e);
      throw e;
    }
  },
  groupLocations(locs, companyData) {
    const projectLocationsKey = `${companyData.name} [Project Delivery Locations]`;
    const pls = _.groupBy(locs, (loc) => {
      if (loc.type === 'company_location') {
        return `${loc.company.name} [Company Locations]`;
      } if (loc.type === 'gi_location') {
        return `${loc.company.name} [General Inventory Locations]`;
      }
      return projectLocationsKey;
    });
    let locations = _.map(pls, (val, key) => ({ key, val }));
    // Ref. Rio#12298.
    locations = _.partition(locations, l => l.key.includes(companyData.name));
    locations = [...locations[0], ..._.sortBy(locations[1], 'key')];
    locations.forEach((loc) => {
      loc.val = _.sortBy(loc.val, 'name');
      if (_.some(loc.val, location => location.nestedLocation === true)) {
        loc.val.unshift(..._.remove(loc.val, location => location.nestedLocation === true));
      }
      if (loc.key === projectLocationsKey) {
        loc.val = _.map(loc.val, l => ({ ...l, nameWithProject: `${l.name} [${l.project[0].name}]` }));
      }
    });
    return locations;
  },
  async allCompanyLocations(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.get('location', { params });
      return {
        data: data.data,
        total: data.totalCount,
      };
    } catch (e) {
      console.log(e);
      throw e;
      // TODO: Throw an error dialog box?
    }
  },
};
